import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6">
      <div className="text-center max-w-md">
        <h1 className="text-7xl font-bold mb-4 text-care-blue">404</h1>
        <img src="/logo-wordmark.png" alt="PrimeShift Group" className="h-8 w-auto mx-auto mb-4" />
        <h2 className="text-2xl font-semibold text-gray-800 mb-3">Page Not Found</h2>
        <p className="text-gray-500 mb-8">The page you are looking for does not exist or has been moved.</p>
        <Link to="/">
          <Button className="gap-2 text-white bg-care-blue hover:bg-care-blue/90" data-testid="back-home-button">
            <ArrowLeft className="w-4 h-4" /> Back to Home
          </Button>
        </Link>
      </div>
    </div>
  );
}
